import type { ExperienceItem } from "../data/portfolio";

type ExperienceSectionProps = {
  experience: ExperienceItem[];
};

const ExperienceSection = ({ experience }: ExperienceSectionProps) => {
  return (
    <section id="experience" className="section">
      <div className="section-header">
        <p className="eyebrow">Experience</p>
        <h2>Teaching, building, and collaborating</h2>
        <p className="lede">
          Roles and contributions that shaped how I design APIs, write resilient UI, and mentor other engineers.
        </p>
      </div>
      <div className="timeline">
        {experience.map((item) => (
          <article key={item.role} className="timeline-item">
            <div className="timeline-meta">
              <p className="eyebrow">{item.timeline}</p>
              <h3>{item.role}</h3>
              <p className="meta">{item.organization}</p>
            </div>
            <ul className="bullet-list">
              {item.details.map((detail) => (
                <li key={detail}>{detail}</li>
              ))}
            </ul>
          </article>
        ))}
      </div>
    </section>
  );
};

export default ExperienceSection;
